"use client";

import { Button } from "@heroui/react";
import { useTranslations } from "next-intl";

export default function MainButton({ title }: { title: string }) {
  const t = useTranslations("buttons");

  return (
    <Button
      className="bg-primary-700 dark:text-primary hover:bg-primary-800 mt-4 w-32 px-6 font-semibold text-white shadow-xl dark:bg-white"
      size="sm"
      variant="primary"
    >
      {t(title)}
    </Button>
  );
}
